import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ChartModule, HighchartsStatic } from '@stackline/angular-highcharts';
import * as Highcharts from 'highcharts';
import * as HighchartsMore from 'highcharts/highcharts-more';
import * as Highcharts3d from 'highcharts/highcharts-3d';
import * as Heatmap from 'highcharts/modules/heatmap';
import * as Treemap from 'highcharts/modules/treemap';
import * as Funnel from 'highcharts/modules/funnel';
import * as SolidGauge from 'highcharts/modules/solid-gauge';
import * as Stock from 'highcharts/modules/stock';
import * as MapModule from 'highcharts/modules/map';
import * as Drilldown from 'highcharts/modules/drilldown';
import * as NoData from 'highcharts/modules/no-data-to-display';

import { AppComponent } from './app.component';

export function highchartsFactory() {
  HighchartsMore(Highcharts);
  Highcharts3d(Highcharts);
  Heatmap(Highcharts);
  Treemap(Highcharts);
  Funnel(Highcharts);
  SolidGauge(Highcharts);
  Stock(Highcharts);
  MapModule(Highcharts);
  Drilldown(Highcharts);
  NoData(Highcharts);
  return Highcharts;
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    ChartModule
  ],
  providers: [
    { provide: HighchartsStatic, useFactory: highchartsFactory }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts